/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useEffect, useState } from "react";
import * as API from "../../http/api";
import { useHistory } from "react-router-dom";
import { closelightbox } from "../../util/Functions";
import { Grid, TextField, Button, DialogActions, DialogContent, Dialog, DialogTitle, IconButton,  List, ListItem } from "@mui/material";
import { ModalStyle } from "../../util/Styles";
import { Close } from "@mui/icons-material";
import { styled } from '@mui/material/styles';
import { address, name } from "../../util/DataObject";

const FireNav = styled(List)({
  '& .MuiListItem-root': {
    padding: 0,
  },
  '& .MuiSvgIcon-root': {
    fontSize: 20,
    marginRight: 16,
  },
});

const AccountCancelBlackList = (props) => {
	const history = useHistory();
  const [zPos, setZPos] = useState(45)
	const [disabled, setDisabled] = useState(true);
	
  const [reason, setReason] = useState('');
  const [error, setErrors] = useState(false);
  const [data, setData] = useState(null)

	useEffect(() => {
		init();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const init = async () => {
    setDisabled(true);
    setData(props.contentModal)
    setReason(JSON.parse(JSON.stringify(''))); 
	};

	const send = async () => {
		props.changeLoader(true);
    setZPos(-1)

    data["reason"] = reason
    let editResponse = await API.service( "editRegisterList", data, props.pos, props.changeAlert, props.changeLoader, history);

		if (editResponse.status === 200) {
			if (editResponse.data.data.response === "OK") {
        props.changeAlert(true, "success", "Registro cancelado con éxito");
				closelightbox();
        await props.reload(props.typeList)
			}
		}
		props.changeLoader(false);
    setZPos(45)
	};

	const changeValue = async (e) => {
		let f = reason;
		let er = error;

    f = e.target.value;
    if (!e.target.value ) {
      er = true;
    } else {
      er = false;
    }

    setReason(JSON.parse(JSON.stringify(f)));
    setErrors(JSON.parse(JSON.stringify(er)));
    validateForm(f, er)
	};

  const validateForm = async (f, err) => {
		(f["reason"] && !err["reason"]) ? setDisabled(true) :	setDisabled(false)
	};

	return (
    <Dialog open={true} sx={{zIndex: zPos, filter: zPos !== 45 ? 'blur(2px)': "none" }} fullWidth>
      <ModalStyle property={String(disabled)}>
        <DialogTitle>
          Cancelar registro
          <IconButton id="headButton" onClick={closelightbox}><Close/></IconButton>
        </DialogTitle>
        
        <DialogContent>
          <Grid container spacing={2} pt={1}>
            <Grid item xs={12}>
              <TextField label="Motivo" value={reason} size="small" fullWidth onChange={changeValue.bind(this)} error={error} helperText={error ? "Dato obligatorio" : ''}/>
            </Grid>
            <Grid item xs={12}>
                <hr style={{margin: "6px 0 14px 0"}}/>
                <p style={{padding: "0px"}}>Información del registro a cancelar:</p>
                <FireNav disablePadding>
                  <List>                    
                    {(typeof data?.value === "string") ?
                      <ListItem style={{fontStyle: "oblique", color: "#969BA0"}}>{data.value}</ListItem>
                      :
                      (((data?.type === "address") &&
                        address.map((a, i) => {
                          return <ListItem key={i} style={{fontStyle: "oblique", color: "#969BA0"}}>{a.label}: {data.value[a.value] || "N/A"}</ListItem>
                        }))
                        ||
                       ((data?.type === "name") &&
                        name.map((a, i) => {
                          return <ListItem key={i} style={{fontStyle: "oblique", color: "#969BA0"}}>{a.label}: {data.value[a.value] || "N/A"}</ListItem>
                        })))
                    }
                  </List>
                </FireNav>
              </Grid>     
          </Grid>
        </DialogContent>

        <DialogActions>    
          <Button id='buttonCancel' variant="outlined" onClick={closelightbox} >Cancelar</Button>     
          <Button disabled={disabled} variant="contained" onClick={send.bind(this)} >Enviar</Button>
        </DialogActions>
      </ModalStyle>
    </Dialog> 
	);
};

export default AccountCancelBlackList;
